import React, { useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DropdownSelect from "../common/DropdownSelect";
import "../../styles/admin/TeacherAssignForm.scss";

const StudentSelectForm = ({
  isOpen,
  onClose,
  onSubmit,
  students = [],
  title = "Add Students",
}) => {
  const [selected, setSelected] = useState([]);

  const options = useMemo(
    () =>
      (students || []).map((s) => ({
        key: s?.id ?? s?._id ?? s?.value ?? s,
        value: s?.id ?? s?._id ?? s?.value ?? s,
        label:
          s?.name && s?.email
            ? `${s.name} (${s.email})`
            : s?.name || s?.label || String(s),
      })),
    [students]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      studentIds: selected?.map((c) => c.key),
    };
    onSubmit && onSubmit(payload);
    setSelected([]);
  };

  const handleClose = () => {
    onClose();
    setSelected([]);
  };

  return (
    <div className="assign-form-overlay">
      <div className="assign-form-container">
        <div className="assign-form-header">
          <h2>{title}</h2>
          <button
            className="assign-close-button"
            onClick={handleClose}
            aria-label="Close"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <form className="assign-form" onSubmit={handleSubmit}>
          <div className="assign-form-group">
            <label htmlFor="students-select">Students</label>
            <DropdownSelect
              inputId="students-select"
              isMulti
              options={options}
              value={selected}
              onChange={(vals) => setSelected(vals || [])}
              placeholder="Select students"
              searchable
            />
          </div>

          <div className="assign-form-actions">
            <button
              type="button"
              className="assign-cancel-button"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="assign-submit-button btn-interactive"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StudentSelectForm;
